document.addEventListener('DOMContentLoaded', function() {
    let isInitialized = false;
    
    // Debounce function to limit rate of search execution
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    // Function to handle search submission
    const handleSearch = debounce(async function(query, formElement) {
        try {
            const response = await fetch(
                `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection,product`
            );
            const data = await response.json();
            
            const allResults = [
                ...(data.resources?.results?.collections || []),
                ...(data.resources?.results?.products || [])
            ];
            
            const redirectUrl = allResults.length > 0 && allResults[0].url
                ? allResults[0].url
                : `${formElement.action}?q=${encodeURIComponent(query)}`;
            
            window.location.href = redirectUrl;
        } catch (error) {
            console.error('Search error:', error);
            window.location.href = `${formElement.action}?q=${encodeURIComponent(query)}`;
        }
    }, 300);

    // Function to initialize search form
    function initializeSearchForm(form, input) {
        if (!form || !input) return false;
        
        const submitHandler = function(event) {
            event.preventDefault();
            const query = input.value.trim();
            if (query) handleSearch(query, form);
        };

        form.addEventListener('submit', submitHandler);
        
        input.addEventListener('keypress', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                submitHandler(event);
            }
        });

        return true;
    }

    // Function to initialize mobile search
    function initializeMobileSearch() {
        if (isInitialized) return;

        const mobileSearchForm = document.querySelector('.cloud-search-mobile form');
        const mobileSearchInput = mobileSearchForm?.querySelector('input[type="search"]');

        if (initializeSearchForm(mobileSearchForm, mobileSearchInput)) {
            isInitialized = true;
            console.log('Mobile search initialized successfully');
        }
    }

    // Initialize desktop search
    const desktopSearchForm = document.querySelector('.main-search__form');
    const desktopSearchInput = desktopSearchForm?.querySelector('.main-search__input');
    initializeSearchForm(desktopSearchForm, desktopSearchInput);

    // Set up mutation observer for mobile form
    const observer = new MutationObserver((mutations) => {
        if (!isInitialized) {
            for (const mutation of mutations) {
                if (mutation.addedNodes.length) {
                    const form = document.querySelector('.cloud-search-mobile form');
                    if (form) {
                        initializeMobileSearch();
                        break;
                    }
                }
            }
        }
    });

    // Start observing with specific configuration
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: false,
        characterData: false
    });

    // Initial attempt
    initializeMobileSearch();

    // Single retry after a delay
    setTimeout(initializeMobileSearch, 1000);
});